// extracted by mini-css-extract-plugin
export default {"notFound":"not-found_notFound__H3xDb","status":"not-found_status__lk98c"};